<template>
  <div style="padding-top: 36px; position: relative;">
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid">
      <div class="card shadow">
        <div class="card-header-pedido">
          <span>Solcitud de pedido</span>
          <Button
            @click="
              (onNewDraft = true), (openDrawer = true), (itemsSelected = [])
            "
            class="add-order-button"
            ><i class="fas fa-plus"></i> Crear pedido</Button
          >
        </div>
        <div class="table-container">
          <div class="table-header-cont">
            <div class="header-item" style="max-width: 40px;">
              ID
            </div>
            <div class="header-item" style="max-width: 105px;">
              Estado
            </div>
            <div class="header-item" style="flex: 2; max-width: 180px;">
              Fecha
            </div>
            <div class="header-item" style="max-width: 100px;">
              Hora
            </div>
            <div class="header-item" style="flex: 3">
              Notas
            </div>
            <div class="header-item">
              Adjuntos
            </div>
            <div class="header-item" style="flex: 1;">
              Acciones
            </div>
          </div>
          <div v-if="customerData && !loading" class="table-rows-cont">
            <div
              v-for="(item, index) in customerData"
              :key="index"
              class="table-row-cont"
            >
              <div class="table-row-item" style="max-width: 40px;">
                {{ item.id }}
              </div>
              <div
                class="table-row-item"
                :class="[item.status]"
                style="max-width: 105px;"
              >
                {{ capitalizeFirstLetter(item.status) }}
              </div>
              <div class="table-row-item" style="flex: 2; max-width: 180px;">
                {{ formatDate(item.creationdate) }}
              </div>
              <div class="table-row-item" style="max-width: 100px;">
                {{ formatTime12h(item.creationtime) }}
              </div>
              <div class="table-row-item" style="flex: 3">
                {{ item.notes }}
              </div>
              <button
                :disabled="getAttachments(item).length === 0"
                @click="handleDropDown(item)"
                class="table-row-item attachment-button"
              >
                <div><i class="fas fa-paperclip"></i> Adjuntos</div>
                <i class="fas fa-caret-down"></i>
                <div
                  v-if="openDropDown && currentRow === item.id"
                  class="dropdown-cont"
                >
                  <a
                    target="_blank"
                    :href="att"
                    class="dropdown-item"
                    v-for="(att, index) in getAttachments(item)"
                    :key="index"
                  >
                    Adjunto {{ index + 1 }}
                  </a>
                </div>
              </button>
              <div
                class="table-row-item"
                style="display: flex; align-items: center; justify-content: center; flex: 1; gap: 8px;"
              >
                <button
                  :disabled="
                    item.status === 'cerrado' || item.status === 'cancelado'
                  "
                  @click="(cancelModal = true), (currentRow = item.id)"
                  class="action-button cancel-button"
                  :class="[
                    item.status === 'cerrado' || item.status === 'cancelado'
                      ? 'disabled-button'
                      : '',
                  ]"
                >
                  Cancelar
                </button>
                <button @click="handleDrawer(item)" class="action-button">
                  Abrir<i
                    class="fas fa-angle-double-right"
                    style="margin-left: 6px;"
                  ></i>
                </button>
              </div>
            </div>
          </div>

          <div class="loading-cont" v-else>Cargando ...</div>
        </div>
      </div>
    </div>
    <div
      class="selected-row-drawer"
      :style="{
        right: openDrawer && (currentRow || onNewDraft) ? '0px' : '-1000px',
      }"
    >
      <div v-if="currentRow" class="drawer-container">
        <div class="drawer-header">
          <span
            ><b class="head-title-id">{{ currentRow }}</b> SOLICITUD DE
            PEDIDO</span
          >

          <Button
            @click="(openDrawer = false), (currentRow = null)"
            class="close-drawer-button"
          >
            <i class="fas fa-times"></i>
          </Button>
        </div>
        <div class="table-container">
          <div class="table-header-cont">
            <div class="header-item" style="max-width: 40px;">
              ID
            </div>
            <div class="header-item" style="flex: 2">
              Código
            </div>
            <div class="header-item" style="flex: 2">
              Nombre
            </div>
            <div class="header-item">
              Cantidad
            </div>
            <div class="header-item">
              Rollos
            </div>
            <div class="header-item">
              Precio
            </div>
            <div class="header-item" style="flex: 2;">
              Notas
            </div>
          </div>
          <div v-if="itemsData" class="table-rows-cont">
            <div
              v-for="(item, index) in itemsData"
              :key="index"
              class="table-row-cont item-row-table"
              style="max-height: 65px;"
            >
              <div class="table-row-item" style="max-width: 40px;">
                {{ item.id }}
              </div>
              <div class="table-row-item" style="flex: 2">
                {{ item.itemcode }}
              </div>
              <div class="table-row-item" style="flex: 2">
                {{ item.itemname }}
              </div>
              <div class="table-row-item">
                {{ item.quantity }}
              </div>
              <div class="table-row-item">
                {{ item.rolls }}
              </div>
              <div class="table-row-item">
                {{ formatCurrency(item.price) }}
              </div>
              <div class="table-row-item" style="flex: 2">
                {{ item.notes }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="onNewDraft" class="drawer-container" style="gap: 16px;">
        <div class="drawer-header">
          <span
            ><b class="head-title-id"><i class="fas fa-plus"></i></b> NUEVA
            SOLICITUD DE PEDIDO</span
          >

          <Button
            @click="
              (openDrawer = false), (onNewDraft = false), (note_message = null)
            "
            class="close-drawer-button"
          >
            <i class="fas fa-times"></i>
          </Button>
        </div>
        <div v-show="!onLoad" class="drawer-head-row">
          <span>Configura tu solicitud de pedido</span>

          <div>
            <button
              :disabled="itemsSelected.length === 0"
              @click="itemsSelected = []"
              class="add-items-button"
              style="margin-right: 12px;"
            >
              <i style="margin-right: 6px;" class="fas fa-minus"></i> Borrar
              lista
            </button>
            <button @click="handleSecondDrawer(true)" class="add-items-button">
              <i class="fas fa-plus"></i> Agregar items
            </button>
          </div>
        </div>
        <div v-show="!onLoad" class="table-container">
          <div class="table-header-cont">
            <div class="header-item" style="max-width: 180px;">
              Código
            </div>
            <div class="header-item">
              Nombre
            </div>
            <div class="header-item">
              Cantidad
            </div>
            <div class="header-item" style="max-width: 100px;">
              Rollos
            </div>
            <div class="header-item" style="max-width: 80px;">
              Precio
            </div>
            <div class="header-item">
              Notas
            </div>
          </div>
          <div
            v-if="itemsSelected.length > 0"
            class="table-rows-cont"
            style="min-height: 40vh; max-height: 40vh;"
          >
            <div
              v-for="(item, _) in itemsSelected"
              :key="_"
              class="table-row-cont item-row-table"
              style="padding: 44px 16px; min-height: 65px;"
            >
              <div class="table-row-item" style="max-width: 180px;">
                {{ item.itemcode }}
              </div>
              <div class="table-row-item" style="line-height: 1.4;">
                {{ item.itemname }}
              </div>
              <div
                class="table-row-item"
                style="display: flex; align-items: center; justify-content:center; flex-direction: column; gap: 6px;"
              >
                <input
                  :value="item.quantity"
                  @input="onEditItem('quantity', $event, item)"
                  type="number"
                  class="input-table"
                  :disabled="item.quantity === null"
                />

                <span v-if="item.unit !== 'ML'">{{ item.unit }}</span>
              </div>
              <div class="table-row-item" style="max-width: 100px;">
                <input
                  :value="item.rolls"
                  @input="onEditItem('rolls', $event, item)"
                  type="number"
                  :disabled="item.rolls === null"
                  class="input-table"
                />
              </div>
              <div
                class="table-row-item"
                style="text-align: right; max-width: 80px;"
              >
                {{ formatCurrency(item.price) }}
              </div>
              <div class="table-row-item">
                <input
                  :value="item.notes"
                  @input="onEditItem('notes', $event, item)"
                  class="input-table"
                />
              </div>
            </div>
          </div>
          <div v-else class="empy-cont">
            <i class="far fa-folder-open"></i>
            <span>No hay items seleccionados</span>
          </div>
        </div>
        <div v-show="!onLoad" class="request-notes-cont">
          <div class="request-col">
            <span>Notas</span>
            <textarea
              id="mensaje"
              v-model="note_message"
              placeholder="Escribe tu nota aquí..."
              rows="5"
              cols="30"
            ></textarea>
          </div>
          <div class="request-row">
            <div class="request-col">
              <span>Archivos adjuntos</span>
              <input type="file" @change="onFileSelected" />
            </div>

            <div class="request-col">
              <span>Archivos adjuntos</span>
              <input type="file" @change="onFileSelected2" />
            </div>
          </div>
        </div>
        <div class="request-button-cont">
          <button v-if="!onLoad" @click="handleSend" class="requestbutton">
            Solicitar pedido
          </button>
          <div class="loading-cont" style="min-height: 50px;" v-else>
            Este proceso puede tardar unos momentos, por favor espera ...
          </div>
        </div>
      </div>
    </div>

    <div
      class="second-drawer"
      :style="{
        right: onSecondDrawer ? '0px' : '-700px',
      }"
    >
      <div class="second-drawer-container">
        <div class="drawer-header">
          <span>Selecciona tus items</span>

          <Button
            @click="handleSecondDrawer(false)"
            class="close-drawer-button"
          >
            <i class="fas fa-times"></i>
          </Button>
        </div>

        <div class="tab-row-cont">
          <button
            @click="selectedTab = 'purchase'"
            :class="[
              'tab-button',
              selectedTab == 'purchase' ? 'tab-button--active' : '',
            ]"
          >
            Pedidos Recientes
          </button>
          <button
            @click="selectedTab = 'items'"
            :class="[
              'tab-button',
              selectedTab == 'items' ? 'tab-button--active' : '',
            ]"
          >
            Mis Artículos
          </button>
        </div>
        <div v-if="selectedTab == 'purchase'" style="padding:16px; align-self: stretch;">
          <input
            @input="onInputChange"
            placeholder="Buscar por # Pedido ..."
            class="searchnums"
          />
        </div>

        <div v-if="selectedTab == 'items'" style="padding:16px; align-self: stretch;">
          <input
            @input="onSearchNyName"
            placeholder="Buscar por nombre ..."
            class="searchnums"
          />
        </div>
        
        <div v-if="selectedTab == 'purchase'" class="select-items-header">
          <div class="select-items-header-item" style="min-width: 100px;">
            # Pedido
          </div>
          <div
            class="select-items-header-item"
            style="flex: 3; justify-content: space-between;"
          >
            Fecha de compra

            <div class="sort-dates-cont">
              <i
                @click="handleDate(true)"
                :class="['fas', 'fa-arrow-down']"
                :style="{
                  color: statusDate === true ? '#F54B4B' : '#00000040',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  transform: !statusDate ? 'rotate(180deg)' : 'rotate(0deg)',
                }"
              ></i>
            </div>
          </div>
          <div
            class="select-items-header-item"
            style="max-width: 120px; justify-content: space-between;"
          >
            Total

            <div class="sort-dates-cont">
              <i
                @click="handleTotal(statusTotal)"
                class="fas fa-arrow-up"
                :style="{
                  color: statusTotal !== null ? '#F54B4B' : '#00000040',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  transform: statusTotal ? 'rotate(180deg)' : 'rotate(0deg)',
                }"
              ></i>
            </div>
          </div>
          <div class="select-items-header-item" style="max-width: 60px;"></div>
        </div>
        <div v-if="selectedTab == 'purchase'" class="full-list-container">
          <div
            v-for="(item, _) in purchaseListCopy"
            :key="_"
            class="item-list-col"
            :class="
              itemsSelected.find(
                (selected) => selected.itemcode === item.ItemCode
              )
                ? '--selected'
                : ''
            "
          >
            <div
              class="item-list-row"
              :style="{
                backgroundColor: orderSelected == item.DocNum ? '#DBDEE1' : '',
                // border: orderSelected == item.DocNum ? '1px solid #A0A8B1' : '',
              }"
            >
              <div class="item-list-row-item" style="min-width: 100px;">
                {{ item.DocNum }}
              </div>
              <div class="item-list-row-item" style="flex: 3;">
                {{ formatDate(item.DocDate) }}
              </div>
              <div
                class="item-list-row-item"
                style="justify-content: flex-end; max-width: 120px; "
              >
                {{ formatCurrency(item.DocTotal) }}
              </div>
              <div
                class="item-list-row-item"
                style="justify-content: flex-end; max-width: 60px;"
              >
                <button
                  @click="handleItems(item.DocNum)"
                  class="expandrowbutton"
                >
                  <i
                    class="fas fa-chevron-down"
                    :style="{
                      transform:
                        orderSelected === item.DocNum
                          ? 'rotate(180deg)'
                          : 'rotate(0deg)',
                      transition: 'all 0.3s ease',
                      color: orderSelected === item.DocNum ? '#C81D25' : '',
                    }"
                  ></i>
                </button>
              </div>
            </div>

            <div
              v-if="orderSelected === item.DocNum"
              class="expanded-items-list"
            >
              <div class="expanded-header">
                <div class="expanded-header-item">
                  Código
                </div>
                <div class="expanded-header-item" style="flex: 2">
                  Nombre
                </div>
                <div
                  class="expanded-header-item"
                  style="max-width: 60px; text-align: right;"
                >
                  Cantidad
                </div>
                <div
                  class="expanded-header-item"
                  style="max-width: 60px; text-align: right;"
                >
                  Rollos
                </div>
                <div
                  class="expanded-header-item"
                  style="max-width: 60px; text-align: right;"
                >
                  Precio
                </div>
                <div
                  class="expanded-header-item"
                  style="max-width: 60px;"
                ></div>
              </div>
              <div v-if="expandedItems.length > 0" class="expandend-rows-cont">
                <div
                  class="expanded-items-list-row"
                  v-for="(item, _) in expandedItems"
                  :key="_"
                  :style="{
                    border: itemsSelected.find(
                      (selected) => selected.itemcode === item.ItemCode
                    )
                      ? '1px solid #faad14'
                      : '',
                    color: itemsSelected.find(
                      (selected) => selected.itemcode === item.ItemCode
                    )
                      ? '#faad14'
                      : '',
                    backgroundColor: itemsSelected.find(
                      (selected) => selected.itemcode === item.ItemCode
                    )
                      ? '#fff7e680'
                      : '',
                  }"
                >
                  <div class="expanded-items-list-row-item">
                    {{ item.ItemCode }}
                  </div>
                  <div class="expanded-items-list-row-item" style="flex: 2">
                    {{ item.ItemDescription }}
                  </div>
                  <div
                    class="expanded-items-list-row-item"
                    style="max-width: 60px; justify-content: flex-end;"
                  >
                    {{ item.Quantity }}
                  </div>
                  <div
                    class="expanded-items-list-row-item"
                    style="max-width: 60px; justify-content: flex-end;"
                  >
                    {{ item.U_Rolls }}
                  </div>
                  <div
                    class="expanded-items-list-row-item"
                    style="max-width: 60px; justify-content: flex-end;"
                  >
                    {{ formatCurrency(item.Price) }}
                  </div>
                  <div
                    class="expanded-items-list-row-item"
                    style="max-width: 60px; display: flex; justify-content: center;"
                  >
                    <button
                      @click="
                        itemsSelected.find(
                          (selected) => selected.itemcode === item.ItemCode
                        )
                          ? removeFromList(item.ItemCode)
                          : addToList(item)
                      "
                      class="addtolistbutton"
                      :style="{
                        backgroundColor: itemsSelected.find(
                          (selected) => selected.itemcode === item.ItemCode
                        )
                          ? '#faad14'
                          : '',
                      }"
                    >
                      <i
                        :class="[
                          'fas',
                          itemsSelected.find(
                            (selected) => selected.itemcode === item.ItemCode
                          )
                            ? 'fa-minus'
                            : 'fa-plus',
                        ]"
                      ></i>
                    </button>
                  </div>
                </div>
              </div>

              <div v-else class="loading-box">
                Cargando ...
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedTab == 'items'" class="select-items-header">
          <div
            class="select-items-header-item"
            style="flex: 3; min-width: 100px;"
          >
            Código
          </div>

          <div class="select-items-header-item" style="flex: 3;">
            Nombre
          </div>

          <div class="select-items-header-item">
            Precio
          </div>
          <div
            class="expanded-items-list-row-item"
            style="max-width: 60px;"
          ></div>
        </div>
        <div v-if="selectedTab == 'items'" class="full-list-container">
          <div
            v-for="(item, _) in itemsListCopy"
            :key="_"
            class="item-list-col"
            :class="
              itemsSelected.find(
                (selected) => selected.itemcode === item.ItemCode
              )
                ? '--selected'
                : ''
            "
          >
            <div
              class="item-list-row"
              :style="{
                border: itemsSelected.find(
                  (selected) => selected.itemcode === item.ItemCode
                )
                  ? '1px solid #faad14'
                  : '',
                color: itemsSelected.find(
                  (selected) => selected.itemcode === item.ItemCode
                )
                  ? '#faad14'
                  : '',
                backgroundColor: itemsSelected.find(
                  (selected) => selected.itemcode === item.ItemCode
                )
                  ? '#fff7e680'
                  : '',
                height: 'auto',
                padding: '6px 0px',
              }"
            >
              <div class="item-list-row-item" style="min-width: 100px;flex: 3;">
                {{ item.ItemCode }}
              </div>
              <div
                class="item-list-row-item"
                style="flex: 3; line-height: 1.1;"
              >
                {{ item.ItemName }}
              </div>
              <div
                class="item-list-row-item"
                style="justify-content: flex-end; max-width: 120px; "
              >
                {{ formatCurrency(item.Price) }}
              </div>
              <div
                class="expanded-items-list-row-item"
                style="max-width: 60px; display: flex; justify-content: center;"
              >
                <button
                  @click="
                    itemsSelected.find(
                      (selected) => selected.itemcode === item.ItemCode
                    )
                      ? removeFromList(item.ItemCode)
                      : addToList(item)
                  "
                  class="addtolistbutton"
                  :style="{
                    backgroundColor: itemsSelected.find(
                      (selected) => selected.itemcode === item.ItemCode
                    )
                      ? '#faad14'
                      : '',
                  }"
                >
                  <i
                    :class="[
                      'fas',
                      itemsSelected.find(
                        (selected) => selected.itemcode === item.ItemCode
                      )
                        ? 'fa-minus'
                        : 'fa-plus',
                    ]"
                  ></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="cancelModal && currentRow" class="pop-up-background">
      <div class="popup-container">
        <img
          src="../assets/warning.png"
          alt=""
          style="max-width: 150px; margin-bottom: 16px;"
        />
        <span
          >Estas por cancelar el pedido con ID: <b>{{ currentRow }}</b></span
        >
        <span><b>¿Estas seguro que desas cancelarlo?</b></span>
        <div class="popup-row">
          <button @click="(currentRow = null), (cancelModal = false)">
            Cerrar
          </button>
          <button @click="handelCancel(currentRow)">Cancelar pedido</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      BASE_URL: process.env.VUE_APP_BASE_URL,
      BASE_HANA: process.env.VUE_APP_HANA_URL,
      EMAIL_CREDIT: process.env.VUE_APP_EMAIL_CREDIT_REQUEST,
      selectedTab: "purchase",
      loading: false,
      onLoad: false,
      rfc: null,
      cardCode: null,
      CardName: null,
      customerData: null,
      currentRow: null,
      openDropDown: false,
      openDrawer: false,
      itemsData: null,
      onNewDraft: false,
      note_message: null,
      onSecondDrawer: false,
      cancelModal: false,
      statusDate: null,
      statusTotal: null,
      orderSelected: null,
      expandedItems: [],
      att_1: null,
      att_link_1: null,
      att_2: null,
      att_link_2: null,
      selectedFile: null,
      purchaseListCopy: [],
      purchaseList: [],
      itemsListCopy: [],
      itemsList: [],
      itemsSelected: [],
    };
  },
  mounted() {
    // this.purchaseListCopy = this.purchaseList;
    let cardcode = "";

    this.loading = true;
    this.rfc = localStorage.getItem("rfc");
    axios.get(`/api/business_part/${this.rfc}`).then((result) => {
      this.cardCode = result.data.value[0].CardCode;
      this.CardName = result.data.value[0].CardName;
      const sql = {
        sql: `SELECT * FROM order_drafts WHERE cardcode = '${this.cardCode}'`,
      };

      const query = `SELECT DISTINCT T1."ItemCode", T2."ItemName", T2."SalUnitMsr", T0."DocNum", T1."Price" 
              FROM CANPLAST."OINV" T0
              INNER JOIN CANPLAST."INV1" T1 ON T0."DocEntry" = T1."DocEntry"
              INNER JOIN CANPLAST."OITM" T2 ON T1."ItemCode" = T2."ItemCode"
              WHERE T0."CardCode" = '${this.cardCode}'
              ORDER BY T0."DocNum" DESC`;

      Promise.all([
        axios.post(`${this.BASE_HANA}/api/sb/general/query`, sql),
        axios.get(
          `${this.BASE_URL}/api/orders/from/costumer?CardCode=${this.cardCode}`
        ),
        axios.post(`${this.BASE_HANA}/api/hana/freedom`, { query }),
      ])
        .then(([response, response2, response3]) => {
          this.customerData = response.data.reverse();
          this.purchaseList = response2.data.value;
          this.purchaseListCopy = response2.data.value;
          this.itemsList = response3.data;
          this.itemsListCopy = response3.data;

          this.loading = false;
        })
        .catch((err) => {
          console.error("Error en alguna de las peticiones:", err);
        });
    });
  },
  methods: {
    handleItems(docnum) {
      this.orderSelected === docnum
        ? (this.orderSelected = null)
        : (this.orderSelected = docnum);

      this.expandedItems = [];

      axios
        .get(`${this.BASE_URL}/api/orders/doc/lines?DocNum=${docnum}`)
        .then((response) => {
          this.expandedItems = response.data.value[0].DocumentLines;
          console.log(this.expandedItems);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleTotal() {
      if (this.statusTotal === true) {
        this.statusTotal = false;
      } else if (this.statusTotal === false) {
        this.statusTotal = null;
      } else {
        this.statusTotal = true;
      }
      this.statusDate = null;

      if (this.statusTotal === true) {
        this.purchaseListCopy = [...this.purchaseList].sort(
          (a, b) => a.DocTotal - b.DocTotal
        );
      } else if (this.statusTotal === false) {
        this.purchaseListCopy = [...this.purchaseList].sort(
          (a, b) => b.DocTotal - a.DocTotal
        );
      } else {
        this.purchaseListCopy = [...this.purchaseList];
      }
    },
    handleDate(sortDate) {
      this.statusDate = this.statusDate === sortDate ? null : sortDate;
      this.statusTotal = null;
      // this.currentStatus = "all";
      // this.filterName = "";
      // this.onSearchByName = false;
      if (this.statusDate === true) {
        this.purchaseListCopy = [...this.purchaseList].sort(
          (a, b) => new Date(a.DocDate) - new Date(b.DocDate)
        );
      } else if (this.statusDate === false) {
        this.purchaseListCopy = [...this.purchaseList].sort(
          (a, b) => new Date(b.DocDate) - new Date(a.DocDate)
        );
      } else {
        this.purchaseListCopy = [...this.purchaseList];
      }
    },
    formatCurrency(value) {
      if (isNaN(value)) return "$0.00 MXN";
      return new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: "MXN",
        minimumFractionDigits: 2,
      }).format(value);
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("es-MX", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      });
      // Ej: "12 de junio de 2025"
    },
    formatTime12h(timeStr) {
      const [hours, minutes, seconds] = timeStr.split(":");
      const date = new Date();
      date.setHours(hours, minutes, seconds);
      return date.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      // Ej: "1:00 AM"
    },
    capitalizeFirstLetter(str) {
      if (!str) return "";
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    getAttachments(obj) {
      return Object.keys(obj)
        .filter((key) => key.startsWith("attachment") && obj[key])
        .map((key) => obj[key]);
    },
    handleDropDown(item) {
      if (item.id === this.currentRow) {
        this.currentRow = null;
        this.openDropDown = false;
      } else {
        this.currentRow = item.id;
        this.openDropDown = true;
      }
    },
    handleDrawer(item) {
      this.currentRow = item.id;
      this.openDrawer = true;
      // console.log(`${this.BASE_HANA}/api/sb/order_drafts/${item.id}/items`);
      axios
        .get(`${this.BASE_HANA}/api/sb/order_drafts/${item.id}/items`)
        .then((response) => {
          this.itemsData = response.data;
          // console.log(response);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleSecondDrawer(state) {
      this.onSecondDrawer = state;
      this.orderSelected = null;
    },
    onInputChange(event) {
      const search = event.target.value.toLowerCase();
      this.purchaseListCopy = this.purchaseList.filter((item) =>
        String(item.DocNum)
          .toLowerCase()
          .includes(search)
      );
    },

    onSearchNyName(event) {
      const search = event.target.value.toLowerCase();
      this.itemsListCopy = this.itemsList.filter((item) =>
        String(item.ItemName)
          .toLowerCase()
          .includes(search)
      );
    },
    addToList(item) {
      const newItem = {
        itemcode: item.ItemCode,
        itemname: item.ItemDescription ? item.ItemDescription : item.ItemName,
        quantity: item.MeasureUnit === "ML" || item.SalUnitMsr === "ML" ? null : 0,
        rolls: item.MeasureUnit === "ML" || item.SalUnitMsr === "ML" ? 0 : null,
        notes: "",
        unit: item.MeasureUnit ? item.MeasureUnit : item.SalUnitMsr,
        price: item.Price,
      };
      this.itemsSelected.push(newItem);
    },
    removeFromList(itemCode) {
      this.itemsSelected = this.itemsSelected.filter(
        (item) => item.itemcode !== itemCode
      );
    },
    onEditItem(type, event, item) {
      const newValue = event.target.value;
      this.itemsSelected.find((i) => i.itemcode === item.itemcode)[
        type
      ] = newValue;
    },
    getCreationDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0"); // +1 porque los meses van de 0 a 11
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    getCreationTime() {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      return `${hours}:${minutes}`;
    },

    procesarArray(arr) {
      return arr.map((item) => {
        const newItem = { ...item };

        // Eliminar el campo 'unit' si existe
        delete newItem.unit;

        for (const key in newItem) {
          const value = newItem[key];

          // Permitir null sin modificar
          if (value === null) {
            newItem[key] = null;
          }

          // Asegurar que rolls y quantity sean número si no son null
          else if (key === "rolls" || key === "quantity") {
            newItem[key] = Number(value);
          }

          // Si es número (y no rolls/quantity), convertir a string
          else if (typeof value === "number") {
            newItem[key] = String(value);
          }
        }

        return newItem;
      });
    },

    handleSend() {
      this.onLoad = true;
      if (this.att_1 || this.att_2) {
        this.uploadFile();
      } else {
        const newDraft = {
          cardcode: this.cardCode,
          cardname: this.CardName,
          creationdate: this.getCreationDate(),
          creationtime: this.getCreationTime(),
          status: "pendiente",
          notes: this.note_message,
          attachment1: this.att_link_1,
          attachment2: this.att_link_2,
        };
        const data = this.procesarArray(this.itemsSelected);
        axios
          .post(`${this.BASE_HANA}/api/sb/order_drafts`, newDraft)
          .then((response) => {
            const id = response.data.id;
            axios
              .post(`${this.BASE_HANA}/api/sb/order_drafts/${id}/items`, data)
              .then((response) => {
                // console.log(response);
                this.reloadItems();
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    handelCancel(id) {
      const data = {
        status: "cancelado",
      };
      axios
        .patch(`${this.BASE_HANA}/api/sb/order_drafts/${id}`, data)
        .then((response) => {
          // console.log(response);
          this.reloadItems();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    reloadItems() {
      const sql = {
        sql: `SELECT * FROM order_drafts WHERE cardcode = '${this.cardCode}'`,
      };
      axios
        .post(`${this.BASE_HANA}/api/sb/general/query`, sql)
        .then((response) => {
          this.customerData = response.data.reverse();
          this.note_message = null;
          this.itemsSelected = [];
          this.openDrawer = false;
          this.onNewDraft = false;
          this.cancelModal = false;
          this.currentRow = null;
          this.att_1 = null;
          this.att_link_1 = null;
          this.att_2 = null;
          this.att_link_2 = null;
          this.onLoad = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    onFileSelected(event) {
      this.att_1 = event.target.files[0];
      // console.log(event);
    },
    onFileSelected2(event) {
      this.att_2 = event.target.files[0];
      // console.log(event);
    },
    async uploadFile() {
      if (this.att_1) {
        const formData = new FormData();
        formData.append("archivo", this.att_1); // 'archivo' es la clave esperada por el servidor
        // console.log(this.att_1.type);

        try {
          const response = await axios.post(
            `${this.BASE_URL}/api/business_partners/pedido/upload?card_code=${
              this.cardCode
            }`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          // console.log("Respuesta:", response);
          this.att_link_1 = response.data.firebase_url;
          if (this.att_2) {
            this.uploadFile2();
          } else {
            const newDraft = {
              cardcode: this.cardCode,
              cardname: this.CardName,
              creationdate: this.getCreationDate(),
              creationtime: this.getCreationTime(),
              status: "pendiente",
              notes: this.note_message,
              attachment1: this.att_link_1,
              attachment2: this.att_link_2,
            };
            const data = this.procesarArray(this.itemsSelected);
            axios
              .post(`${this.BASE_HANA}/api/sb/order_drafts`, newDraft)
              .then((response) => {
                const id = response.data.id;
                axios
                  .post(
                    `${this.BASE_HANA}/api/sb/order_drafts/${id}/items`,
                    data
                  )
                  .then((response) => {
                    // console.log(response);
                    this.reloadItems();
                  })
                  .catch((err) => {
                    console.error(err);
                  });
              })
              .catch((err) => {
                console.error(err);
              });
          }
        } catch (error) {
          console.error("Error:", error);
        }
      } else {
        this.uploadFile2();
      }
    },
    async uploadFile2() {
      if (!this.att_2) return;

      const formData = new FormData();
      formData.append("archivo", this.att_2); // 'archivo' es la clave esperada por el servidor
      // console.log(this.att_2.type);

      try {
        const response = await axios.post(
          `${this.BASE_URL}/api/business_partners/pedido/upload?card_code=${
            this.cardCode
          }`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log("Respuesta:", response);
        this.att_link_2 = response.data.firebase_url;
        const newDraft = {
          cardcode: this.cardCode,
          cardname: this.CardName,
          creationdate: this.getCreationDate(),
          creationtime: this.getCreationTime(),
          status: "pendiente",
          notes: this.note_message,
          attachment1: this.att_link_1,
          attachment2: this.att_link_2,
        };
        const data = this.procesarArray(this.itemsSelected);
        axios
          .post(`${this.BASE_HANA}/api/sb/order_drafts`, newDraft)
          .then((response) => {
            const id = response.data.id;
            axios
              .post(`${this.BASE_HANA}/api/sb/order_drafts/${id}/items`, data)
              .then((response) => {
                // console.log(response);
                this.reloadItems();
              })
              .catch((err) => {
                console.error(err);
              });
          })
          .catch((err) => {
            console.error(err);
          });
      } catch (error) {
        console.error("Error:", error);
      }
    },
  },
};
</script>

<style>
.loading-box {
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  font-size: 14px;
  font-style: italic;
  text-align: center;
}
.card {
  min-height: 80vh;
  border-radius: 16px;
  overflow: hidden;
}
.card-header-pedido {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  background-color: #f6f9fc;
  gap: 16px;
  line-height: 1.1;
}

.table-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
}

.table-header-cont {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  height: 35px;
  background-color: #e9ecef;
  gap: 12px;
  padding: 0px 12px;
  box-sizing: border-box;
}

.header-item {
  flex: 1;
  font-weight: 600;
  font-size: 14px;
  text-align: left;
  border-right: 2px solid #00000010;
  /* padding: 0px 16px; */
  box-sizing: border-box;
}

.header-item:last-of-type {
  border: none;
}

.table-rows-cont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  max-height: 80vh;
  min-height: 80vh;
  overflow: auto;
}

.table-row-cont {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  height: 35px;
  max-height: 35px;
  gap: 12px;
  padding: 0px 12px;
}

.table-row-cont:nth-child(even),
.item-list-row:nth-child(even) {
  background-color: #e9ecef40;
}

.table-row-cont:nth-child(odd),
.item-list-row:nth-child(odd) {
  background-color: #ffffff;
}

.table-row-item {
  flex: 1;
  font-weight: 400;
  font-size: 14px;
  /* padding: 0px 16px; */
  box-sizing: border-box;
}

.cerrado,
.pendiente,
.cancelado {
  text-align: center;
  border-radius: 99px;
  background-color: #d9f7be80;
  border: 1px solid #52c41a80;
  color: #52c41a;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pendiente {
  background-color: #fff7e680;
  border: 1px solid #faad1480;
  color: #faad14;
}

.cancelado {
  background-color: #f9b6c080;
  border: 1px solid #cb334b80;
  color: #cb334b;
}

.attachment-button {
  text-align: center;
  border-radius: 99px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  background-color: #e9ecef80;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.20); */
  cursor: pointer;
  transition: all 0.3s ease;
  height: 22px;
  position: relative;
  border: none;
}

.attachment-button:active,
.attachment-button:focus {
  outline: none;
}

.attachment-button:hover {
  background-color: #f6f9fc;
}

.action-button {
  /* border: 1px solid; */
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  font-weight: 600;
  background-color: #e9ecef80;
  /* box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.20); */
  cursor: pointer;
  transition: all 0.3s ease;
  height: 22px;
  flex: 1;
  border: none;
  /* max-width: 150px; */
}

.action-button:active,
.action-button:focus {
  outline: none;
}

.action-button:hover {
  background-color: #cb334b;
  color: #fff;
}

.cancel-button:hover {
  background-color: #444446;
}

.disabled-button:hover {
  background-color: #e9ecef80;
  color: #00000040;
}

.fa-paperclip {
  font-size: 12px;
  margin-right: 2px;
}

.sort-dates-cont {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  color: #00000040;
}

.dropdown-cont {
  width: 220px;
  height: auto;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 8px;
  background-color: #fff;
  position: absolute;
  z-index: 99;
  top: 24px;
  left: 0px;
  border-radius: 12px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}

.dropdown-item {
  width: 100%;
  height: 30px;
  border-radius: 99px !important;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #e9ecef;
  border-radius: 99px;
  cursor: pointer;
}

.selected-row-drawer {
  width: 950px;
  height: 100vh;
  max-height: 100vh;
  padding-bottom: 36px;
  overflow: auto;
  position: fixed;
  top: 0px;
  background-color: #fff;
  box-shadow: -12px 0px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  z-index: 98;
}

.drawer-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  /* gap: 16px; */
  align-self: stretch;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
  font-size: 18px;
  font-weight: 600;
}

.close-drawer-button {
  height: 30px;
  width: 30px;
  background-color: #e9ecef;
  border: none;
  border-radius: 99px;
  transition: all 0.3s ease;
  font-size: 12px;
}

.close-drawer-button:hover {
  background-color: #cb334b;
  color: #fff;
}

.head-title-id {
  background-color: #cb334b;
  padding: 4px 8px;
  margin-right: 4px;
  color: #fff;
}

.item-row-table {
  height: auto;
  min-height: 45px;
  line-height: 1.1;
  padding-top: 8px;
  padding-bottom: 8px;
}

.add-order-button {
  border: none;
  padding: 8px 20px;
  border-radius: 99px;
  font-weight: 600;
  font-size: 14px;
  background-color: #e9ecef;
  transition: all 0.3s ease;
}

.add-order-button:hover {
  background-color: #9d3337;
  color: #fff;
}

.add-order-button:active,
.add-order-button:hover,
.add-order-button:focus {
  border: none;
  outline: none;
}

.add-order-button .fa-plus {
  margin-right: 6px;
}

.drawer-head-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  align-self: stretch;
  padding: 0px 24px;
}

.add-items-button {
  border: none;
  border-radius: 99px;
  background-color: #e9ecef;
  padding: 6px 16px;
  font-size: 14px;
  /* max-height: 30px;
  display: flex;
  align-items: center;
  justify-content: center; */
}

.add-items-button .fa-plus {
  margin-right: 6px;
}

.empy-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-direction: column;
  gap: 12px;
  color: #00000020;
  font-size: 44px;
  min-height: 30vh;
  border-bottom: 1px solid #dcdcdc80;
}

.empy-cont span {
  font-weight: 400;
  font-size: 18px;
}

.request-notes-cont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  padding: 0px 24px;
}

.request-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  gap: 8px;
}

.request-col span {
  font-size: 14px;
  color: #00000080;
}

.request-col textarea {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #dcdcdc80;
  box-sizing: border-box;
  padding: 12px;
  font-size: 14px;
}

.request-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  margin-top: 16px;
  gap: 16px;
}

.request-row .request-col {
  flex: 1;
}

.add-file-container {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 6px;
  cursor: pointer;
}

.add-file-container .fa-plus {
  font-size: 24px;
}

.request-button-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  margin-top: 16px;
}

.requestbutton {
  border: none;
  padding: 8px 16px;
  border-radius: 99px;
  background-color: #9d3337;
  color: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
}

.requestbutton:hover {
  background-color: #cb334b;
}

.requestbutton:active {
  background-color: #d6465b;
}

.requestbutton:active,
.requestbutton:hover,
.requestbutton:focus {
  border: none;
  outline: none;
}

.second-drawer {
  z-index: 99;
  width: 530px;
  height: 100vh;
  position: fixed;
  top: 0px;
  background-color: #fff;
  box-shadow: -12px 0px 12px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.second-drawer-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  /* gap: 16px; */
  align-self: stretch;
}

.select-items-header {
  align-self: stretch;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 35px;
  background-color: #e9ecef;
}

.select-items-header-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 600;
  font-size: 13px;
  padding: 0px 16px;
}

.full-list-container {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  max-height: 90vh;
  overflow: auto;
  /* margin-top: -16px; */
}

.item-list-col {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-direction: column;
}

.item-list-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  /* padding: 16px; */
  box-sizing: border-box;
  font-size: 14px;
  height: 35px;
  min-height: 35px;
  border-bottom: 1px solid #dcdcdc;
  /* color: #000; */
}

.item-list-row-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0px 16px;
}

.expandrowbutton {
  background-color: transparent !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  color: #525f7f;
  transition: all 0.3s ease;
}

.expandrowbutton:focus,
.expandrowbutton:active {
  outline: none;
}

.expanded-items-list {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  border-bottom: 1px solid #dcdcdc;
  overflow: auto;
  max-height: 400px;
}

.expanded-items-list-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  border-bottom: 1px solid #dcdcdc;
  padding: 4px 16px;
  gap: 8px;
  /* min-height: 50px; */
  /* min-height: 60px; */
}

.expanded-items-list-row-item {
  flex: 1;
  font-size: 12px;
  display: flex;
  align-items: center;
}

.addtolistbutton {
  height: 25px;
  width: 25px;
  border-radius: 99px;
  border: none;
  background-color: #c81d25;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.addtolistbutton:hover {
  background-color: #9d3337;
}

.addtolistbutton:focus {
  outline: none;
}

.addtolistbutton:active {
  outline: 2px solid #9d3337;
}

.addtolistbutton .fa-plus {
  margin-top: 1px;
}

.expanded-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  min-height: 35px;
  padding: 0px 16px;
  background-color: #e9ecef;
  gap: 8px;
}

.expanded-header-item {
  flex: 1;
  font-size: 12px;
  font-weight: 600;
}

.expandend-rows-cont {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  align-self: stretch;
  min-height: 300px;
  max-height: 400px;
  overflow: auto;
}

.searchnums {
  border-radius: 99px;
  height: 35px;
  width: 100%;
  font-size: 14px;
  padding: 0px 12px;
  border: 1px solid #dcdcdc80;
  transition: all 0.3s ease;
}

.searchnums::placeholder {
  color: #00000040;
  font-style: italic;
}

.searchnums:focus,
.searchnums:active {
  outline-color: #9d3337;
}

.--selected {
  background-color: #f6f9fc;
}

.input-table {
  max-width: 100%;
  border: 1px solid #dcdcdc80;
  border-radius: 8px;
  height: 30px;
  box-sizing: border-box;
  padding: 6px;
}

.loading-cont {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  min-height: 30vh;
  font-weight: 600;
}

.pop-up-background {
  width: 100%;
  height: 100vh;
  background-color: #00000050;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 156px;
}

.popup-container {
  /* width: 650px; */
  /* height: 300px; */
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 8px;
  padding: 36px 86px;
  font-size: 18px;
  color: #000;
  font-weight: 400;
  line-height: 1.2;
}

.popup-row {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  gap: 16px;
  margin-top: 24px;
}

.popup-row button {
  border: none;
  padding: 8px 18px;
  border-radius: 99px;
  font-size: 16px;
  font-weight: 600;
}

.popup-row button:last-of-type {
  background-color: #c81d25;
  color: #ffffff;
}

.popup-row button:active,
.popup-row button:focus {
  outline: none;
}

.tab-row-cont {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  padding: 0px 16px;
  padding-top: 16px;
  gap: 0px;
}

.tab-button {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  padding: 6px;
  border: none;
  font-size: 13px;
  background-color: #e9ecef;
  color: #525f7f;
  font-weight: 600;
  transition: all 0.3s ease;
}

.tab-button--active {
  background-color: #c81d25;
  color: #fff;
}

.tab-button:active,
.tab-button:focus {
  outline: none;
}

.tab-button:first-of-type {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

.tab-button:last-of-type {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}
</style>
